import { paths } from '~/util/router/Routing'
import { trimLastSlash } from '~/util/helpers/string'

const validateProp = (target, prop) => {
  if (!target[prop]) {
    console.warn('Custom Nuxt Routing plugin: No such a property in paths ', prop)
    return false
  }
  return true
}

export default ({ app }, inject) => {
  const PathsProxy = new Proxy(paths, {
    get(target, prop) {
      const isValidProp = validateProp(target, prop)
      if (!isValidProp) return
      if (typeof target[prop].path === 'function') {
        return function(...args) {
          return trimLastSlash(app.localePath(target[prop]?.path.apply(this, args)))
        }
      }
      if ('modal' in target[prop] && 'path' in target[prop]) {
        return trimLastSlash(app.localePath(target[prop].path))
      }
      if ('modal' in target[prop]) {
        return target[prop]?.modal
      }
      else {
        return trimLastSlash(app.localePath(target[prop].path))
      }
    },
  })
  const PathObjProxy = new Proxy(paths, {
    set() {
      console.error('You should not change $paths, $pathObj')
      return false
    },
    get(target, prop) {
      const isValidProp = validateProp(target, prop)
      if (!isValidProp) return

      return new Proxy(target[prop], {
        get(target, prop, receiver) {
          if (typeof target[prop] === 'function') {
            return function(...args) {
              return trimLastSlash(app.localePath(target[prop].apply(this, args)))
            }
          }
          else if (prop === 'path' || prop === 'redirect') {
            return trimLastSlash(app.localePath(target[prop]))
          }
          else if (prop === 'title') {
            if (!target[prop]) return ''
            return target[prop][app.i18n.locale]
          }
          return Reflect.get(target, prop, receiver)
        },
      })
    },
  })
  if (app.prototype) {
    app.prototype.$paths = PathsProxy
    app.prototype.$pathObj = PathObjProxy
  }
  inject('paths', PathsProxy)
  inject('pathObj', PathObjProxy)
}
